<template>
  <basic-list
    :show-select-col="true"
    :show-page="!!state.showPage"
    :show-action-col="false"
    :show-index-col="false"
    select-type="singleMult"
    :fields="fields"
    :loading="state.loading"
    :total="state.total"
    :list="state.list"
    :table-h="tableH"
    :table-code="tableCode"
    :lazy="true"
    :load="loadChilden"
    :tree-props="{ children: 'children', hasChildren: 'hasChild' }"
    row-key="id"
    :page-index="state.pageIndex"
    :page-size="state.pageSize"
    :page-index-change="pageIndexChange"
    :page-size-change="pageSizeChange"
    :selection-change="selectionChange">
    <template slot="hd-col--l">
      <el-button
        type="primary"
        size="small"
        @click="proxyActions({ action: 'setAdd', rows: selRows })"
        v-if="buttonData('szjgcjgly').has"
      >{{buttonData('szjgcjgly').name}}</el-button>
    </template>
  </basic-list>
</template>

<script>
import ExactList from "@/mixins/exactList";
export default {
  mixins: [ExactList],
  props: {
    handleAdd: Function,
    handleDelete: Function,
    handleEdit: Function,
    handleUers: Function,
    handleOrg: Function,
    checkSingleRow: Function,
    proxyActions: Function,
    loadChilden: Function,
    orgTypes: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      //
      fields: [
        // 列表显示字段
        { key: "orgName", name: `${this.$t('language.5o6otz4p17k0')}`, align: "left", minWidth: 280 },
        {
          key: "orgFullName",
          name: `${this.$t('language.5o6otz4p1bo0')}`,
          align: "left",
          render: (h, { index, row, col }) => {
            return <span>{row.orgFullName}</span>;
          },
          minWidth: 280
        },
        {
          key: "isOwnOrg",
          name: `${this.$t('language.5o6u3wttvb00')}`,
          width: 270,
          render: (h, { index, row, col }) => {
            if (row.isOwnOrg === 0) {
              return <span class='cell-others-style cell-common'>{this.$t('language.5o6uj7uyta00')}</span>;

            } else {
              return  <span class='cell-menu-style cell-common'>{this.$t('language.5o6uj7uytcs0')}</span>;

            }
          }
        },
        { key: 'orgCode', name: `${this.$t('language.5o6otz4p1hc0')}`, width: 160 },
        { key: "principal", name: `${this.$t('language.5o6otz4p1kc0')}`, width: 160 },
        {
          key: "orgType",
          name: `${this.$t('language.5o6otz4p1n40')}`,
          width: 120,
          render: (h, { index, row, col }) => {
            const currentRow = this.orgTypes.filter(function(item) {
              return item.key === row.orgType;
            });
            return <span>{currentRow.length ? currentRow[0].value : ""}</span>;
          }
        },
        { key: "orgSource", name: `${this.$t('language.5o6otz4p1ps0')}`, width: 160 },
        { key: "createTime", name: `${this.$t('language.5o6otz4p1t00')}`, width: 160 },
        { key: "remark", name: `${this.$t('language.5o6otz4p1w00')}`}
      ]

    };
  }
};
</script>
<style lang="scss">
.el-table__header-wrapper {
  /deep/ .el-table__header {
    .is-left {
      text-align: center;
    }
  }
}
</style>
